import { NuxtIconsInitializer } from '@tokyojob/frontend-components'

const IconLibrary = new NuxtIconsInitializer()
IconLibrary.init()
